import {useState,useEffect} from 'react'
export default function UseFetch(url){
const[data,setData]=useState([]);
const[loading,setLoading]=useState([]);
useEffect(() => {
    if (!url){
    return setLoading(true)
    }
async function getData(){
    const response = await fetch(url);
    if(!response.ok){
        throw new Error(`http error! status:${response.status}`);
    }
    const data=await response.json();
    setData(data);
    setLoading(false);
}
getData()
}, [url])
return {data,loading}
}